import { getPrincipiosActivos, getPrincipioActivo, deletePrincipioActivo, editPrincipioActivo, createPrincipioActivo } from "../../../helpers/backend_helper";
import {  apiError, principiosActivosSuccess, principioActivoSuccess, principiosActivosDeleteSuccess, reset_principiosActivos_flag,} from "./reducer";

export const getPrincActivos = () => async (dispatch) => {
  try {
    const response = getPrincipiosActivos();
    const data = await response;

    if (data) {
      dispatch(principiosActivosSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};
 
export const deletePrincActivo = (id) => async (dispatch) => {
  try {
    const response = deletePrincipioActivo(id);
    const data = await response;
    if (data) {
      dispatch(principiosActivosDeleteSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const editPrincActivo = (principioActivo) => async (dispatch) => {
  try {
    //console.log("editPrincActivo:", principioActivo);
    
    const response = editPrincipioActivo(principioActivo);
    const data = await response;
    if (data) {
      dispatch(principioActivoSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createPrincActivo = (principioActivo) => async (dispatch) => {
  try {
    const response = createPrincipioActivo(principioActivo);
    const data = await response;  

    if (data) {
      dispatch(principioActivoSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getPrincActivo = (id) => async (dispatch) => {
  try {
    
    //console.log("getPrincActivo:", id);
    
    const response = getPrincipioActivo(id);
    const data = await response;
    //console.log("getPrincActivo:", data);
    
    if (data) {
      dispatch(principioActivoSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetPrincipiosActivosFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_principiosActivos_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

//getPrincActivos, deletePrincActivo, editPrincActivo, createPrincActivo , getPrincActivo,  resetPrincipiosActivosFlag